import React, { useEffect, useState } from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col, Form } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { blockDriver } from "../../Services/Driver.service";
import { changePassword } from "../../Services/Auth.service";
import { useController, useForm } from "react-hook-form";

const HardResetPassword = ({ Large, title, LargeModaltoggle, employeeObj }) => {
    const [loading, setLoading] = useState(false);
    const [toggleNewPassword, setToggleNewPassword] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        control,
        reset,
        setValue,
        formState: { errors },
    } = useForm();

    

    const submitForm = (values) => {
        setLoading(true)
        const body = {
            userId: employeeObj.userId,
            oldPassword: values.new_password,
            newPassword: values.new_password,
            hardReset: true
        };
        changePassword(body)
            .then((result) => {
                setLoading(false)
                reset()
                setToggleNewPassword(false)
                console.log(result, "result");
                showAlert("success", "Password Updated Successfully");
                LargeModaltoggle()
            })
            .catch((error) => {
                const errorRes = error.response;
                console.log(errorRes, "errorReserrorReserrorRes");
                setLoading(false)
                showAlert(
                    "error",
                    errorRes.data?.message
                        ? errorRes.data?.message
                        : "Something went wrong"
                );
            });
    };


    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={()=> {
                reset()
                setToggleNewPassword(false)
                LargeModaltoggle()
            }}
            size="md"
        >
            <Row className="driver-push-notification">
                <Form onSubmit={handleSubmit(submitForm)}>
                    <Col xl="12" className="push-botification-body">
                        <div>{"New Password"}</div>
                        <input
                            className="form-control"
                            style={{color: "black"}}
                            {...register("new_password", {
                              required: {
                                value: true,
                                message: "New Password is required",
                              },
                              minLength: {
                                value: 5,
                                message: "Password cannot be less than 5 characters",
                              },
                              onChange: (e) => {
                                setValue("new_password",e.target.value.trimStart())
                              }
                            })}
                            type={toggleNewPassword ? "text" : "password"}
                        />
                        <div
                            className="show-hide"
                            onClick={() => setToggleNewPassword(!toggleNewPassword)}
                        >
                            <span className={toggleNewPassword ? "" : "show"}></span>
                        </div>
                        <span style={{ color: "red" }}>
                            {errors?.new_password?.message}
                        </span>
                    </Col>

                    <Col xl="12" className="push-notification-footer">
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "LOADING..." : "Update Password"}
                        </button>
                    </Col>
                </Form>
            </Row>
        </CommonModal>
    );
};

export default HardResetPassword;
